import { useState, useEffect } from "react";
import "./DateRangeBadge.scss";

function DateRangeBadge({
  range,
  setTimeRange,
  setShowDateRangeBadge,
  timeOptions,
}) {
  const [visible, setVisible] = useState(true);

  //   if (!visible) return null;

  const formatDate = ({ year, month }) => {
    const date = new Date(year, month);
    return date.toLocaleString("default", {
      month: "short",
      year: "numeric",
    });
  };

  useEffect(() => {
    if (range?.from?.year) {
      setVisible(true);
    }
  }, [range]);

  return (
    visible && (
      <div className="d-inline-flex text-nowrap align-items-center bg-light border rounded-pill px-3 py-2 badge-container">
        <span className="me-3 fw-medium ">
          {formatDate(range.from)} → {formatDate(range.to)}
        </span>

        <button
          type="button"
          className="btn btn-sm p-0 border-0 bg-transparent"
          onClick={() => {
            setVisible(false);
            setTimeRange(timeOptions[0]);
            setShowDateRangeBadge(false);
          }}
        >
          ✕
        </button>
      </div>
    )
  );
}

export default DateRangeBadge;
